import {createAuthGuard} from '@gatewee/services';

import {AuthService} from '../_services/auth/auth.service';

export const authGuard = createAuthGuard(AuthService);
